import { Logo } from '../components/Logo'
import { Usda } from '../components/Usda';
import {
  PageContainer,
  HeroSection,
  HeroContent,
  BackLink,
  ContentSection,
  Container,
  MainContent,
  SideContent,
  ProductTitle,
  ProductSubtitle,
  SectionTitle,
  SubSectionTitle,
  Paragraph,
  InfoTable,
  TableRow,
  TableDataLabel,
  TableData,
  List,
  AcoContainer,
  DecorativeElement
} from './ProductStyles';

export const PelargoniumGraveolens15 = () => (
  <PageContainer>
    <HeroSection>
      <BackLink to="/">ホームに戻る</BackLink>
      <HeroContent>
        <Logo />
      </HeroContent>
    </HeroSection>

    <ContentSection>
      <Container>
        <MainContent>
          <DecorativeElement className="top-right" />
          <DecorativeElement className="bottom-left" />

          <ProductTitle>ブルボン産 ゼラニウム (ロット15)</ProductTitle>
          <ProductSubtitle>Pelargonium graveolens</ProductSubtitle>

          <SectionTitle>使用期限</SectionTitle>
          <Paragraph>{new Date('2027-06-30T00:00:00.000+09:00').toLocaleDateString()}</Paragraph>

          <SectionTitle>製品の特徴</SectionTitle>
          <InfoTable>
            <tbody>
              <TableRow>
                <TableDataLabel>原産国</TableDataLabel>
                <TableData>ブルボン</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出部位</TableDataLabel>
                <TableData>葉と葉先</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出方法</TableDataLabel>
                <TableData>水蒸気蒸留法</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>学名</TableDataLabel>
                <TableData>Pelargonium graveolens</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>科名</TableDataLabel>
                <TableData>フウロソウ科</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>効果</TableDataLabel>
                <TableData>スキンケア、香料、リラクゼーション</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>INCI名</TableDataLabel>
                <TableData>Pelargonium Graveolens (Geranium) Oil</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>CAS番号</TableDataLabel>
                <TableData>8000-46-2 ; 90082-51-2</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>品質</TableDataLabel>
                <TableData>100% Pure and Natural</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>ノート分類</TableDataLabel>
                <TableData>ミドル〜トップノート</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>ロット番号</TableDataLabel>
                <TableData>15</TableData>
              </TableRow>
            </tbody>
          </InfoTable>

          <SectionTitle>分析証明書</SectionTitle>

          <SubSectionTitle>製品識別と組成</SubSectionTitle>
          <List>
            <li>製品名: Geranium Essential Oil 100% Pure and Natural (ロット15)</li>
            <li>学名: Pelargonium graveolens</li>
            <li>バッチ番号: 10782506</li>
          </List>

          <SubSectionTitle>物理的および化学的特性</SubSectionTitle>
          <List>
            <li>外観: 淡黄色から淡緑がかった黄色の液体</li>
            <li>香り: とてもフレッシュで、軽やかにフローラル、レモンとローズが感じられるアロマ</li>
            <li>屈折率: 1.464 @ 20°C</li>
            <li>比重: 0.893 @ 20°C</li>
            <li>旋光度: -18° 〜 -7°</li>
            <li>溶解性: アルコール類および固定油に可溶、水に不溶</li>
          </List>

          <SubSectionTitle>主要成分（EU アレルゲン申告）</SubSectionTitle>
          <List>
            <li>シトロネロール (Citronellol): 30.0%</li>
            <li>ゲラニオール (Geraniol): 20.0%</li>
            <li>リナロール (Linalool): 11.0%</li>
            <li>β-カリオフィレン (Beta-Caryophyllene): 1.6%</li>
            <li>テルピネオール (Terpineol): 1.2%</li>
            <li>シトラール (Citral): 1.0%</li>
            <li>ピネン (Pinene): 0.8%</li>
            <li>リモネン (Limonene): 0.5%</li>
          </List>

          <SubSectionTitle>品質検査</SubSectionTitle>
          <List>
            <li>微生物検査: 全項目適合（ISO 21149, ISO 16212, ISO 18416, ISO 21150, ISO 22717, ISO 22718）</li>
            <li>重金属検査: 全項目適合（鉛 &lt; 10ppm、ヒ素 &lt; 2ppm、水銀 &lt; 1ppm）</li>
            <li>IFRA適合: 第51次改正（2023年7月公布）準拠</li>
          </List>

          <SubSectionTitle>保管方法</SubSectionTitle>
          <Paragraph>密閉容器に入れ、直射日光を避けて冷暗所に保管してください。36ヶ月以上保管した場合は、使用前に品質を確認してください。</Paragraph>
        </MainContent>

        <SideContent>
          <AcoContainer>
            <Usda />
          </AcoContainer>
        </SideContent>
      </Container>
    </ContentSection>
  </PageContainer>
);
